export default __webpack_public_path__ + "static/media/counter-icon-3.c4dace32.svg";